import React, {Component} from 'react';
import { withRouter } from "react-router-dom";






class AddLostItemWeb extends Component {
    constructor(props) {
      super(props);
  
      this.state = {
      
      };
    }
   
  
    // <img className='text-center' style={{maxWidth:650, width:"100%",maxHeight:800, height:"100%"}} src='./images/users.png' alt=''/> 
    render() {
        return (

            <div className='jumbotron'>
                <h2>Add A Lost / Found Item in BOUNTE Venue &trade;</h2>

                <br/>


                
                <p className='text-primary'>1) tap or Click "Lost &amp; Found" in the main menu along the top.   </p>
                <div className="text-center">
                    <img className='text-center' style={{width:800,height:600}} src='./images/lostitems.png'  alt=''/> 
                </div> <br/> <br/>
              

                <p className='text-primary'>2) Tap or click "Add Item" </p>

                    <div className="text-center">
                        <img className='text-center' style={{width:90,height:75}} src='./images/additem.png'  alt=''/> 
                
                    
                    </div>

                <br/>
                <hr/>


                <h5>Add A Lost / Found Item in BOUNTE Venue &trade;</h5>




                <p className='text-primary'>

                </p>

                <div className="text-center">
                    <img className='text-center' style={{width:'100%',height:'90%'}} src='./images/newlostitem.png'  alt=''/> 


                </div>

                <br/>

                <p className='text-primary'>
                Edit lost and found items screen is the primary area within the website to enter a new lost and found items or edit existing lost and found items. This screen consists of two major sections. The image in the map section. 
                <br/>  <br/>
The detail entry section consists of the title description any internal claim challenged information. This is similar to the mobile apps entry screen. The title and the description are both required. 
<br/>  <br/>
<h6>The internal clean challenge details </h6> Describes specific attributes of the lost & found item that only the guest wouldn't know. An example would be An inscription or noticeable markings that only someone who had that item in their possession would know. 
<br/>  <br/>
<h6>Expensive Items </h6> 
Expensive item switch should be set on for items that are considered expensive and need to be placed in a secure location.
<br/>  <br/>

<h6>keywords</h6> 
The keywords text box are used to enter keywords or tags that best describe the item that was found. An example of this would be Silver, black, analog, scratched.  These keywords are used to help search for items within this system.
<br/>  <br/>

<h6>Location</h6> 
The location text entry is used to specify where the item was found. Ie. Room 1107 or "Hotel lobby Bar"
<br/>  <br/>
<h6>Storage Location</h6> 
The Storage Location text entry is used to specify where the item is being stored. Some hotels have multiple lost and found locations. This can be a description of the item where the item is stored. Or a code that the hotel would like to reuse.
<br/>  <br/>


<h6>Date Found</h6> 
The "date found" field is the date of when the item was found. The Found by drop-down we'll list all the users active within the system that you can assign.
<br/>  <br/>

<h6>Status</h6> 

The status drop-down indicates the current status of the lost item. Status options are Unclaimed, Claimed, archived and returned.  The status of unclaimed means the item is still in the lost and found and nobody has called the claimant. Claimed indicates that either was shipping label was created for the item or a claim item was linked to the lost and found item to indicate that it was claimed. Bounty will automatically assign the status claimed when performing either the other functions within the system. Archived means that the item was archived and no longer important or used within the system. Return status meetings the item was returned to the customer or guest. When a shipping label is put on a box and shipped back to the user will update the Lost & found record to "returned".
<br/>  <br/>
<h6>Claims section</h6> 
The claim section will display a list of all the people that claimed this item. This typically will only be one person. When creating a shipping label using the shipping label return Wizzard the claim will be auto-generated behind the scenes and will display within this list. You can click on a row within the list of claims to see details and edit the claim information right from the screen. You can also get to claims by clicking on the claim menu item at the top.
<br/>  <br/>
<h6>Update</h6> 

UPDATE: when the detail items map and pictures are all defined and have been entered by the user, click update to save them back to the database. Any errors or omissions of data will result in an error message being displayed in red and the upper right-hand corner. Successfully saving will show a green indicator stating that the item was saved to the database.
<br/>  <br/>
<h6>Shipping Label</h6> 
To create a new shipping label click the green button create a shipping label. This will launch the lost item shipping label return wizard covered in the "Create Shipping Label Section"
<br/>  <br/>
<h6>DPrint Inventory tracking Label</h6> 
To print an inventory tracking label click the button labeled print inventory tracking label. This will create a pop-up screen from which you can print to a standard size printer or a 4 x 6 thermal printer.

                </p>
               

                 <br/> 
                


                <br/>

                 
                
            </div>
        )
       


    }

}
export default withRouter(AddLostItemWeb);
